import defaultTheme from './defaultTheme';
const crateAndBarrelTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#000000', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#000000', background: '#000000' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#000000' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#000000', border: '#000000', background: '#000000' }), field: {
        focus: '#000000',
        label: '#000000',
        icon: '#000000',
    } });
export default crateAndBarrelTheme;
